/* eslint-disable no-param-reassign */
import axios, { InternalAxiosRequestConfig } from "axios";
import { v4 as uuidv4 } from "uuid";

const serverHttpInstance = axios.create({
  baseURL: process.env.NEXT_PRIVATE_API_BASE_URL,
});

const clientHttpInstance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_BASE_URL,
});

const applicationServiceHttpInstance = axios.create({
  baseURL: process.env.NEXT_PRIVATE_APPLICATION_API_URL,
});

const affiliateServiceHttpInstance = axios.create({
  baseURL: process.env.NEXT_PRIVATE_AFFILIATE_API_URL,
});

clientHttpInstance.interceptors.request.use((config) => addRequestId(config));

const addRequestId = (config: InternalAxiosRequestConfig) => {
  if (!config?.headers["x-request-id"]) {
    config.headers["x-request-id"] = uuidv4();
  }
  return config;
};

// TODO, will fix this later
// clientHttpInstance.interceptors.request.use((requestConfig: AxiosRequestConfig<any>) => {
//   requestConfig.headers['x-request-id'] = generateRequestId();
// });

// const generateRequestId = () => {
//   const reqId = uuidv4();
//   sessionStorage.setItem('reqId', reqId);
//   return reqId;
// }

export {
  serverHttpInstance,
  clientHttpInstance,
  applicationServiceHttpInstance,
  affiliateServiceHttpInstance,
};
